module.exports = __webpack_public_path__ + "img/Lajos.7ac58474.png";